export default __webpack_public_path__ + "static/card_img-2-8431b871ff2ae9310831fd1308b3ab3c.jpg";